import { Children, Fragment, cloneElement } from "react"

import { 
  parseEntityValue 
} from '../../../../../../utils/courseCatalogueManager'

const TableRow = ({
  row,
  labels,
  isMobile,
  fieldToHeader,
  type,
  columnsPerFieldMap,
  fieldOptions,
  rowClassName,
  onClickHandler,
  className,
  onMouseDown,
  children,
}) => (
  <div
    className={`rounded mb-2 ${
      Children.count(children) !== 0
        ? "d-flex justify-content-between align-items-stretch gap-1 gap-xl-4"
        : ""
    } table-row ${className || ""}`}
  >
    <div
      className={`p-3 ${
        isMobile ? "" : "d-flex"
      } justify-content-around align-items-center custom-row ${
        Children.count(children) !== 0 ? `${rowClassName}` : ``
      } 
       
       ${isMobile ? "mobile" : "desktop"}
      `}
      onClick={onClickHandler}
      onMouseDown={onMouseDown}
    >
      {labels.map((key, idx) => {
        if (key === "id") return null

        const value = row[key]

        const renderValue = () => {
          if (Array.isArray(value) && value.length > 0 && typeof value[0] !== "object") {
            return value.map((entry, i) => {

              return (
                <span key={i} className="me-2">{parseEntityValue(key, entry, fieldOptions)}</span>
              )
              
            })
          } else if (Array.isArray(value) && value.length > 0 && typeof value[0] === "object") {
            return value.map((entry, i) => {
              const lang = entry.lang || ""
              const text = entry.string || entry.multiline || entry.uri || ""

              return (
                <div key={i}>
                  <span className="fw-bold">{parseEntityValue(key, text, fieldOptions)}</span> 
                  {lang.length !== 0 && <span className="ms-2">({parseEntityValue(key, lang, fieldOptions)})</span>}
                </div>
              )

            })
          }

          // Primitive values
          if (value !== null && value !== undefined && typeof value !== "object") {
            return parseEntityValue(key, value, fieldOptions)
          }

          return null
        }

        return (
          <Fragment key={"row-col-" + idx}>
            {isMobile ? (
              <div className="row">
                <div className="col table-header">
                  {fieldToHeader(key) ? fieldToHeader(key) + ":" : ""}
                </div>
                <div className="col body">{renderValue()}</div>
              </div>
            ) : (
              <div className={`px-2 ${columnsPerFieldMap[key]}`}>
                <div className="text-lg-start text-break body">{renderValue()}</div>
              </div>
            )}
          </Fragment>
        )
      })}
      {isMobile &&
        Children.map(
          children,
          (child) =>
            child &&
            cloneElement(child, {
              onClick: (e) => {
                e.stopPropagation();
              },
            })
        )}
    </div>
    {!isMobile && children}
  </div>
);

export default TableRow;
